import { render } from "./Menu.vue?vue&type=template&id=778d554e&scoped=true"
const script = {}

import "./Menu.vue?vue&type=style&index=0&id=778d554e&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778d554e"]])

export default __exports__